import gql from 'graphql-tag'
export default gql`
query getInvoiceFormatList{
    getInvoiceFormatList{
      domain
      typeValue
      companyName
      companyLogo{
        bucket
        region
        key
      }
      address
      email
      mobile
      gst
      custKOTPrint
      noOfInvoice
      custName
      hideRewardPoints
      hideAddonsOnInvoice
      printZeroPriceAddons
      custMobile
      custAddress
      editCustDetails
      invoiceOptionOnBill
      itemShiftKot
      shareOnWebWhatsapp
      printHSNCodeOnBill
      printNoOfInvoice
      printCashGivenOnInvoice
      itemInstructionOnBill
      paytmQrOptions
      siteURL
      footerMessage
      a4FooterMessage
      a4PaymentDetails
      token
      qrcode{
        bucket
        region
        key
      }
      paymentMode
      printOperatorInfo
      isPayQR
      upiId
      itemInstructionOnBill
    }
  }`